import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { InterceptorSkipHeader } from 'app/auth/auth.interceptor';
import { API_ENDPOINTS } from 'app/core/constants/api-endpoints.constant';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ProjectInsuranceService {
    constructor(private http: HttpClient) {}

    sendProjectInsuranceData(data): Observable<any> {
        return this.http.post(
            API_ENDPOINTS.BASE_URL + '' + `${API_ENDPOINTS.INSURANCE_LEADS}`,
            data,
            {
                headers: { [InterceptorSkipHeader]: InterceptorSkipHeader },
            }
        );
    }
}
